<template>
  <div :key="componentType.id">
    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    computed: {
        ...mapGetters([
            'componentType',
        ]),
    },
    async beforeRouteUpdate(to, from, next) {
        if (from.params.componentTypeId !== to.params.componentTypeId) {
            if (await this.getComponentTypeInfo(to.params.componentTypeId)) {
                next();
            }
        } else {
            next();
        }
    },
    methods: {
        ...mapActions({
            getComponentTypeInfo: 'getComponentTypeInfo',
        }),
    },
};
</script>
